module.exports = __webpack_public_path__ + "img/231-complated.56264c6e.png";